import React, { useContext } from 'react';

import { CompanyContext } from 'common/containers/CompanyContainer';
import { RouterContext } from 'common/containers/RouterContainer';
import AdminQueueAlert, {
  AlertTypes,
} from 'common/subdomain/admin/AdminQueue/AdminQueueAlerts/AdminQueueAlert';
import ButtonV2 from 'common/ui/ButtonV2';
import { P } from 'common/ui/Text';
import isOnNewPricingPlan from 'common/util/isOnNewPricingPlan';

const AdminQueueCreditWarning = () => {
  const router = useContext(RouterContext);
  const company = useContext(CompanyContext);

  // new pricing plans have "unlimited" credits, so hide this warning
  if (isOnNewPricingPlan(company.billingData?.plan?.planID)) {
    return null;
  }

  return (
    <AdminQueueAlert
      type={AlertTypes.warning}
      text={
        <P>
          Your Autopilot credits are running low. Purchase more now to avoid interruptions in
          your&nbsp;service.
        </P>
      }
      actions={
        <ButtonV2 onClick={() => router.push('/admin/settings/billing/autopilot')} size="medium">
          Purchase credits
        </ButtonV2>
      }
    />
  );
};

export default AdminQueueCreditWarning;
